import { useState } from 'react';
import { Star } from 'lucide-react';
import { useStore } from '../../store/useStore';
import { weeklyInsightsEnabled } from '../../native/insightsGate';
import { CoreGuidance, CoreStar } from './CoreStar';

/**
 * "★ Choose your focus projects" — every tag in one place, each with its
 * star, so nobody has to find a task, open it and open its tag picker
 * just to set focus (Chad, 18 Oct 2026: four taps deep was too hidden).
 * Lives on the review card and in "Where your weeks go". Web only.
 */
export function FocusPicker() {
  const tags = useStore((s) => s.tags);
  const [open, setOpen] = useState(false);
  if (!weeklyInsightsEnabled()) return null;
  const all = Object.values(tags).sort((a, b) => a.name.localeCompare(b.name));
  if (all.length === 0) return null;
  const starred = all.filter((t) => t.core);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center gap-1 text-[11px] font-bold text-amber-700 dark:text-amber-300 hover:underline"
      >
        <Star size={12} className="text-amber-500" fill={starred.length ? 'currentColor' : 'none'} />
        {starred.length === 0
          ? 'Choose your focus projects'
          : `Focus: ${starred.map((t) => t.name).join(', ')} · change`}
      </button>
    );
  }

  return (
    <div
      role="group"
      aria-label="Choose your focus projects"
      className="space-y-2 rounded-lg border border-amber-200 dark:border-amber-500/30 bg-amber-50/60 dark:bg-amber-900/10 p-2"
    >
      <p className="text-[11px] font-semibold text-slate-700 dark:text-slate-200">
        Star the 3–5 you’re focusing on right now. Change them whenever your priorities change.
      </p>
      <div className="flex flex-wrap gap-1.5">
        {all.map((tag) => (
          <span
            key={tag.id}
            className="inline-flex items-center rounded-full border pl-2 text-[11px] font-bold"
            style={{ color: tag.color, borderColor: tag.core ? tag.color : `${tag.color}55`, backgroundColor: tag.core ? `${tag.color}1a` : 'transparent' }}
          >
            {tag.name}
            <CoreStar tagId={tag.id} />
          </span>
        ))}
      </div>
      <CoreGuidance />
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-2.5 py-1 text-[11px] font-bold text-slate-700 dark:text-slate-200"
      >
        Done
      </button>
    </div>
  );
}
